import ko from "knockout";
import Component from "flow/Component";
import Stack from "flow/experimental/Stack";
import { Dictionary } from "flow/api/types";

export interface IComponentConfig<T = Dictionary> {
    component: Component;
    viewContext: T;
    stack?: Stack;
    skipActivation?: boolean;
    popCallback?: (arg?: any) => void;
    preventDestroy?: boolean;
}

export interface IEmbeddedComponentParams {
    config: IComponentConfig | KnockoutObservable<IComponentConfig>;
    stretch?: boolean;
    stretch100?: boolean;
}

ko.components.register("ko-embedded-component", {
    viewModel: function (params: IEmbeddedComponentParams) {
        const config = ko.utils.unwrapObservable(params.config);
        this.stretchAbsolute = params.stretch === undefined ? true : params.stretch;
        this.stretch100 = params.stretch100 === undefined ? true : params.stretch100;

        this.component = config.component;
        this.viewContext = config.viewContext;
        const skipActivation = config.skipActivation;

        this.component
            .safeLoad()
            .done(() => {
                if (!skipActivation) {
                    this.component.activate(this.viewContext);
                }
                this.component.onShow();
            })
            .fail(() => {
                this.component.myFlow.notifyError(
                    this.component.myFlow.translate("FlowHtml.Translations.FailedToLoadEmbeddedComponent") +
                        ": " +
                        this.component.myFlow.manifest.id
                );
            });

        this.dispose = () => {
            this.component.onHide();
            if (!config.preventDestroy) {
                this.component.onDestroy();
            }
        };
    },
    template: `<div data-bind="flowComponent: component, css: { 'lc-fc-stretch-absolute': stretchAbsolute, 'h-100': stretch100, 'lc-container--broken': component.isBroken, 'lc-loading-layer': component.isLoading }"></div>`
});
